import PropTypes from 'prop-types';
import React from 'react';

import SmartX from './SmartX';

const SmartTouch = ({ className }) => (
  <SmartX
    className={className}
    heading="Touch"
    image="/customProduct/smart-touch-logo.png"
    list={[
      'CON·X·US Standard Equipment',
      'Cascade Sequencer for up to 8 units',
      'Loch-N-Link',
      'Low Water Flow Safety Control and Indication',
      'Ramp Delay (Boiler Only)'
    ]}
    paragraph="This ultimate control gives installers and facility managers access to all of the information they need to set up, troubleshoot and monitor all equipment functions with a multi-color touchscreen interface. Diagnostic information and system status are presented in real words, not codes."
  />
);

SmartTouch.propTypes = {
  className: PropTypes.string
};

export default SmartTouch;
